import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { propertySet, propertyUpdate, propertyUpdates } from "../../../services/propertyUpdate";
import { Choice, Question, Questionnaire } from "./questionnaire";
import { FormNamingUtil } from "../utils/form-naming.util";

export function getSelectedAnswers(control: AbstractControl, questionIndex: number, questions: Question[]) : Choice[] {
  // Find the question by array index instead of questionNumber
  const questionObj = questions[questionIndex];
  if (!questionObj) {
    return [];
  }

  if (control instanceof FormArray) {
    let selectedChoices : Choice[] = [];
    control.controls.forEach((answer, index) => {
      if (answer.value) {
        // Use the choice at the same index in the options array
        selectedChoices.push(questionObj.options[index]);
      }
    });
    return selectedChoices;
  } else {
    // For single choice, find by choice text (this is correct for single choice)
    return questionObj.options.filter(option => option.choice == control.value);
  }
}

export function formToPayload(questionnaire: Questionnaire, questionnaireForm: FormGroup, invisibleSubQuestions?: Set<string>): any {
  let questionMap = new Map<string, any>();
  questionnaire.questions.forEach((question, questionIndex) => {
    let isHiddenSubQuestion = false;
    if (invisibleSubQuestions && invisibleSubQuestions.has(question.id)) {
      isHiddenSubQuestion = true;
    }
    
    let questionControl = questionnaireForm.controls[FormNamingUtil.getQuestionName(questionIndex)];
    let values = getSelectedAnswers(questionControl, questionIndex, questionnaire.questions);

    let choicesMap = new Map<string, any>();
    question.options.forEach(o => {
      choicesMap.set(o.id, {
        choiceNumber: propertySet(o.choiceNumber),
        text: propertySet(o.choice),
        exclusive: propertySet(o.exclusive),
        ...o.freeTextLabel != null && { additionalInformationLabel: propertySet(o.freeTextLabel) }
      })
    });

    let questionContract = {
      questionNumber: propertySet(question.questionNumber),
      label: propertySet(question.label),
      choices: Object.fromEntries(choicesMap),
      questionType: propertySet(question.questionType),
      isHidden: propertySet(isHiddenSubQuestion)
    }

    if (values != null) {
      let questionAdditionalInfoControl = questionnaireForm.controls[FormNamingUtil.getAdditionalInfoName(questionIndex)];

      let selectedChoices = values.map(value => value.choice);
      let additionalInformationText = questionAdditionalInfoControl?.value;

      question.answer = {
        choices: selectedChoices,
        additionalInformation: additionalInformationText
      }

      let answer = {
        choices: propertySet(selectedChoices),
        ...questionAdditionalInfoControl != null
        && { additionalInformation: propertyUpdate(questionAdditionalInfoControl, x => x) }
      }

      questionMap.set(question.id, {
        question: questionContract,
        answer: answer
      })
    }
    else {
      return questionMap.set(question.id, {
        question: questionContract
      });
    }
  })

  return propertyUpdates({
    questionnaireId: propertySet(questionnaire.questionnaireId),
    name: propertySet(questionnaire.name),
    version: propertySet(questionnaire.version),
    questions: Object.fromEntries(questionMap)
  });
}
